import React, { useMemo, useState } from 'react';
import {
    getPspLabel,
    getPspLogoAsset,
    normalizePspCode,
} from 'utils/psp';

type PSPLogoProps = {
    psp: string;
    width?: string;
    height?: string;
    marginLeft?: string;
};

const PSPLogo: React.FC<PSPLogoProps> = ({
    psp,
    width = '32px',
    height = '32px',
    marginLeft = '16px',
}) => {
    const [hasError, setHasError] = useState(false);
    const asset = useMemo(() => getPspLogoAsset(psp), [psp]);
    const code = normalizePspCode(psp)?.toUpperCase() || 'PSP';
    const label = getPspLabel(psp) || code;

    if (!asset || hasError) {
        return (
            <span
                title={label}
                aria-label={label}
                style={{
                    width,
                    height,
                    minWidth: width,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft,
                    border: '1px solid currentColor',
                    borderRadius: '8px',
                    fontSize: '9px',
                    fontWeight: 700,
                    lineHeight: 1,
                    opacity: 0.72,
                    direction: 'ltr',
                    boxSizing: 'border-box',
                }}>
                {code}
            </span>
        );
    }

    return (
        <img
            style={{
                width,
                height,
                marginLeft,
                objectFit: 'contain',
            }}
            src={`/images/psp/${asset}.svg`}
            alt={label}
            title={label}
            onError={() => setHasError(true)}
        />
    );
};

export default PSPLogo;
